











































































































import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import { WidgetConfiguration } from "../interfaces/widgetConfiguration";
import { WidgetState } from "../interfaces/widgetState";
import { WidgetPayload } from "../interfaces/widgetPayload";
import JitsiWidget from "@/components/widgets/jitsi/JitsiWidget.vue";
import ChatWidget from "@/components/widgets/chat/ChatWidget.vue";
import RadioButtonWidget from "@/components/widgets/radioButton/RadioButtonWidget.vue";
import DrawWidget from "@/components/widgets/draw/DrawWidget.vue";
import FileagentWidget from "@/components/widgets/fileagent/fileAgentWidget.vue";
import PlyrWidget from "@/components/widgets/plyr/PlyrWidget.vue";
import CloudflareplayerWidget from "@/components/widgets/cloudflareplayer/CloudflareplayerWidget.vue";
import MarkdownWidget from "@/components/widgets/markdown/MarkdownWidget.vue";
import { StudioAttributes } from "../interfaces/studioAttributes";

@Component({
    components: {
        JitsiWidget,
        ChatWidget,
        RadioButtonWidget,
        DrawWidget,
        FileagentWidget,
        PlyrWidget,
        MarkdownWidget,
        CloudflareplayerWidget,
    },
})
export default class MobileWidgetGrid extends Vue {
    @Prop() showId?: boolean;
    @Prop() canControl?: boolean;
    @Prop() configurations!: WidgetConfiguration<WidgetState, WidgetPayload>[];
    @Prop() fullscreenWidgetId!: string | null;
    @Prop() showTitle?: boolean;

    public deleteDialog: boolean = false;
    public deleteWidgetId: string | null = null;
    public editedTitle: string = "";
    public widgetHeight: number = 0;
    public activeWidget: WidgetConfiguration<
        WidgetState,
        WidgetPayload
    > | null = null;
    public localOldConfig: WidgetConfiguration<
        WidgetState,
        WidgetPayload
    >[] = [];

    public get isPresenter(): boolean {
        return this.$store.getters.isPresenter;
    }

    @Emit() remove(widgetId: string | null) {
        this.deleteDialog = false;
        this.deleteWidgetId = null;
        return widgetId;
    }

    // public printer() {
    //     console.log(this.activeWidget, this.configurations);
    // }

    @Watch("configurations")
    public configWatcher() {
        if (
            this.activeWidget &&
            this.configurations.findIndex(
                x => x.widgetId == this.activeWidget?.widgetId
            ) == -1
        ) {
            // z.b bei pagewechsel, verschwindet das widget
            this.activeWidget = null;
        }
        if (this.configurations.length > this.localOldConfig.length) {
            const newWidget = this.configurations.filter(
                x => !this.localOldConfig.includes(x)
            )[0];
            this.activeWidget = newWidget;
        }
        this.localOldConfig = [...this.configurations];
    }
    public mounted() {
        this.localOldConfig = [...this.configurations];
        this.widgetHeight = window.innerHeight - 60;
        if (this.configurations) {
            this.activeWidget = this.configurations[0];
        }
        window.addEventListener(
            "resize",
            () => {
                // console.log("resize", window.outerHeight);
                this.widgetHeight = window.innerHeight - 60;
            },
            { passive: true }
        );
    }
    public updateTitle(event: {
        config: WidgetConfiguration<WidgetState, WidgetPayload>;
        payload: WidgetPayload;
    }) {
        this.editedTitle = "";
        this.update(event);
    }

    public editBtnHandler(widgetId: string) {
        if (this.editedTitle == widgetId) {
            this.editedTitle = "";
        } else this.editedTitle = widgetId;
    }

    @Emit() update(event: {
        config: WidgetConfiguration<WidgetState, WidgetPayload>;
        payload: WidgetPayload;
    }) {
        return event;
    }

    @Emit() public studioAttributesChanged(event: Partial<StudioAttributes>) {
        return event;
    }
    @Emit() public requestToolbar() {
        return;
    }

    public removeStart(widgetId: string) {
        this.deleteWidgetId = widgetId;
        this.deleteDialog = true;
    }

    public removeCancel() {
        this.deleteDialog = false;
        this.deleteWidgetId = null;
    }
    public leave() {
        this.$router.back();
    }
}
